import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { AnimationOptions } from "ngx-lottie";
import { Subscription } from "rxjs";
import { DineinTableLabelService } from "../../../services/dinein-table-label/dinein-table-label.service";
import { DineinTableLabelContext } from "../../../services/dinein-table-label/dinein-table-label.helpers";

@Component({
  selector: "app-no-scanner-available-modal",
  templateUrl: "./no-scanner-available-modal.component.html",
  styleUrls: ["./no-scanner-available-modal.component.scss"],
})
export class NoScannerAvailableModalComponent implements OnInit, OnDestroy {
  @Input() branchLink;
  @Input() group;
  @Input() hideSecondMessage;
  @Input() otherAndroidUrl;
  @Input() otherIosUrl;
  @Input() showDownloadNowButton;
  @Input() forOnlyAppsDinein;
  @Input() webOnlyDineIn;
  @Input() selectedStore;
  @Input() selectedLang;
  @Input() app_name;
  public nativePlatform: string;
  public titleTranslationKey = "download_app";
  public primaryMessageTranslationKey = "download-app-to-scan-qr";
  public animationOptionsAndroid: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/download-now-android.json",
  };

  public animationOptionsIos: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/download-now-ios.json",
  };
  public animationOptionsWebOnlyDineIn: AnimationOptions = {
    path: "https://data.deliverymanager.gr/animations/scan-qr-1.json",
  };
  public unsubscribeBackEvent: any;

  public dineinTableContext: DineinTableLabelContext = null;
  private dineinTableContextSub: Subscription;

  constructor(
    private readonly modalController: ModalController,
    private platform: Platform,
    private dineinTableLabelService: DineinTableLabelService
  ) {}

  ngOnInit() {
    this.dineinTableContextSub =
      this.dineinTableLabelService.context$.subscribe((context) => {
        this.dineinTableContext = context;
      });
    this.unsubscribeBackEvent = this.platform.backButton.subscribeWithPriority(
      300,
      () => {
        if (this.platform.is("android")) {
          this.closeModal();
        }
      }
    );
    if (this.platform.is("android")) {
      this.nativePlatform = "android";
    } else if (this.platform.is("ios")) {
      this.nativePlatform = "ios";
    } else if (this.platform.is("desktop")) {
      this.nativePlatform = null;
    }

    if (this.webOnlyDineIn) {
      this.titleTranslationKey = "delivery-method-address.dinein-ordering";
      this.primaryMessageTranslationKey = "open_camera_and_scan_table_qr";
    } else if (this.forOnlyAppsDinein) {
      this.primaryMessageTranslationKey = "download-app-to-order-dinein";
    }

    console.log("platform", this.nativePlatform);
  }

  async closeModal(): Promise<void> {
    this.modalController.dismiss();
  }

  openLink(link) {
    window.open("https://" + link);
  }

  ngOnDestroy(): void {
    if (this.dineinTableContextSub) {
      this.dineinTableContextSub.unsubscribe();
    }
    if (this.unsubscribeBackEvent) {
      this.unsubscribeBackEvent.unsubscribe();
    }
  }
}
